// The API's renderer camelizes every dict key — including keys that are really DATA, like a
// service name or a skip reason. So a count map keyed `vehicle_history` server-side arrives here
// as `vehicleHistory`, and a label table keyed the server's way misses it and shows the raw key.
// Looked up both ways, so a table needs only the server's own spelling.
export const toSnake = key => String(key ?? '').replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase()

export const labelFor = (labels, key) => (labels || {})[key] || (labels || {})[toSnake(key)]
